import React, { useState, useEffect, useContext } from "react";
import ReactDOM from "react-dom";
import {
  MenuContainer,
  SubMenuContainer,
  MenuList,
  MenuItem,
  MenuItemLink,
  MainMenuItemLink,
  ExternalMenuItemLink,
  SubMenuList,
  MenuItemTitle,
  Arrow,
} from "./styles";

import MenuLoader from "loader/MenuLoader";
import { CompetitionContext } from "contexts/CompetitionContext";
import useOutsideClose from "hooks/useOutsideClose";
import useBreakpoints from "hooks/useBreakpoint";

export default function Menu({ open, onClose, roles, loading, overlay }) {
  const [menuItems, setMenuItems] = useState([]);

  const [menuItemSelected, setMenuItemSelected] = useState(0);

  const { currentCompetitionOpened } = useContext(CompetitionContext);

  const { node } = useOutsideClose(() => onClose());
  const { IsLessThan } = useBreakpoints();
  const isMobile = IsLessThan("laptop");

  useEffect(() => {
    setMenuItems([
      {
        id: 40,
        title: "Información",
        visible: true,
        links: [
          {
            id: 80,
            title: "Postularse",
            // Sólo mientras la competición vigente esté abierta.
            visible: currentCompetitionOpened,
            href: "/postularse",
          },
          /*{
          id: 110,
          title: "Entradas",
          visible: true,
          external: true,
          href: "https://www.eventbrite.com.ar/e/983902848907?aff=oddtdtcreator",
        },*/
          {
            id: 220,
            title: "Temáticas",
            visible: true,
            href: "/tematicas",
          },
          {
            id: 160,
            title: "Reglamento",
            visible: true,
            href: "/reglamento",
          }]
      },
      {
        id: 80,
        title: "Ediciones Anteriores",
        visible: true,
        href: "/ediciones-anteriores",
        links: [],
      },
      /* {
         id: 90,
         title: "Sponsors",
         visible: true,
         anchor: true,
         href: "#sponsors",
         links: [],
       },*/
      {
        id: 1,
        title: "Jurado",
        visible: roles.judge || roles.selector || roles.administrator,
        links: [
          {
            id: 2,
            title: "Preselección",
            visible: roles.selector,
            href: "/jurado/preseleccion",
          },
          {
            id: 15,
            title: "Finalistas",
            visible: roles.administrator,
            href: "/jurado/finalistas",
          },
          {
            id: 10,
            title: "Votación",
            visible: roles.judge,
            href: "/jurado/votacion",
          },
          {
            id: 12,
            title: "Estado de la votación",
            visible: roles.administrator,
            href: "/jurado/estado-votacion",
          },
          {
            id: 24,
            title: "Ganadores",
            visible: roles.administrator,
            href: "/jurado/ganadores",
          },
        ],
      },
      {
        id: 3,
        title: "Postulaciones",
        visible: roles.administrator,
        links: [
          {
            id: 5,
            title: "Listado",
            visible: true,
            href: "/postulaciones",
          },
          {
            id: 17,
            title: "Restauración",
            visible: true,
            href: "/postulaciones/restauracion",
          },
        ],
      },
      {
        id: 6,
        title: "Administración",
        visible: roles.administrator,
        links: [
          // Tres grupos, separados por una línea: la edición (lo que se arma
          // antes de abrir la postulación), el contenido público del sitio y
          // los usuarios. `groupStart` marca el primer link de cada grupo.
          {
            id: 10,
            title: "Competiciones",
            visible: true,
            href: "/administracion/competiciones",
          },
          {
            id: 7,
            title: "Temáticas",
            visible: true,
            href: "/administracion/tematicas",
          },
          {
            id: 13,
            title: "Criterios",
            visible: true,
            href: "/administracion/criterios",
          },
          {
            id: 14,
            title: "Ceo",
            visible: true,
            href: "/administracion/ceo",
          },
          {
            id: 21,
            title: "Noticias",
            visible: true,
            groupStart: true,
            href: "/administracion/noticias",
          },
          {
            id: 20,
            title: "Galería",
            visible: true,
            href: "/administracion/galeria",
          },
          {
            id: 18,
            title: "Menciones",
            visible: true,
            href: "/administracion/menciones",
          },
          {
            id: 19,
            title: "Ganadores",
            visible: true,
            href: "/administracion/ganadores",
          },
          {
            id: 12,
            title: "Auspiciantes",
            visible: true,
            href: "/administracion/auspiciantes",
          },
          {
            id: 9,
            title: "Usuarios",
            visible: true,
            groupStart: true,
            href: "/administracion/usuarios",
          },
        ],
      },
    ]);
  }, [roles, currentCompetitionOpened]);

  useEffect(() => {
    handleMenuItemUnSelected();
  }, [open]);

  const handleClickOnMenuItem = (id) => {
    if (menuItemSelected === id) {
      handleMenuItemUnSelected();
    } else {
      setMenuItemSelected(id);
    }
  };

  const handleMenuItemUnSelected = () => {
    setMenuItemSelected(0);
  };

  const canHover =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const handleMouseEnterOnMenuItem = (id) => {
    if (canHover) {
      setMenuItemSelected(id);
    }
  };

  const menuContent = (
    <MenuContainer>
      {loading ? (
        <MenuLoader />
      ) : (
        <MenuList ref={node} open={open} overlay={overlay}>
          {menuItems
            .filter((menuItem) => menuItem.visible)
            .map((menuItem) => {
              return (
                menuItem.links.length === 0 ?
                  (<MainMenuItemLink key={menuItem.id} onClick={onClose} to={menuItem.href} href={menuItem.href} >
                    {menuItem.title}
                  </MainMenuItemLink>) :
                  <MenuItem
                    key={menuItem.id}
                    onClick={() => {
                      handleClickOnMenuItem(menuItem.id);
                    }}
                    onMouseEnter={() => {
                      handleMouseEnterOnMenuItem(menuItem.id);
                    }}
                    onMouseLeave={() => {
                      handleMenuItemUnSelected();
                    }}
                  >
                    <MenuItemTitle selected={menuItem.id === menuItemSelected}>
                      {menuItem.title}{" "}
                      <Arrow selected={menuItem.id === menuItemSelected} />
                    </MenuItemTitle>

                    <SubMenuContainer selected={menuItem.id === menuItemSelected}>
                      <SubMenuList selected={menuItem.id === menuItemSelected}>
                        {menuItem.links
                          .filter((link) => link.visible)
                          .map((link) => {
                            return (
                              <MenuItem
                                key={link.id}
                                data-group-start={link.groupStart || undefined}
                              >
                                {link.external ? (
                                  <ExternalMenuItemLink
                                    onClick={onClose}
                                    href={link.href}
                                    target="_blank"
                                  >
                                    {link.title}
                                  </ExternalMenuItemLink>
                                ) : (
                                  <MenuItemLink onClick={onClose} to={link.href}>
                                    {link.title}
                                  </MenuItemLink>)}
                              </MenuItem>)
                          })}
                      </SubMenuList>
                    </SubMenuContainer>
                  </MenuItem>
              );
            })}
        </MenuList>
      )}
    </MenuContainer>
  );

  return isMobile
    ? ReactDOM.createPortal(menuContent, document.body)
    : menuContent;
}
